import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import {styles, Classes} from './styles';
import {Avatar} from '@material-ui/core';
import {OwnProps} from './typedef';

type IProps = Classes & OwnProps;

const UserInfo = (props: IProps) => {
    const {classes, user} = props;

    return (
        <div className={classes.userInfo}>
            {user.avatarUrl ?
                <Avatar
                    alt={`${user.firstName} ${user.lastName}`}
                    src={user.avatarUrl}
                    className={classes.userAvatar}
                /> :
                <Avatar className={classes.userAvatar}>{user.firstName.charAt(0)}</Avatar>
            }
            <Typography
                variant="body2">
                {user.firstName ? `${user.firstName} ${user.lastName}` : 'John Smith'}
            </Typography>
        </div>
    );
};

export default withStyles(styles)(UserInfo);
